(function() {
    'use strict';

    angular
        .module('app.layout')
        .controller('LayoutController', LayoutController);

    LayoutController.$inject = [ '$stateParams', 'dataservice'];
    /*@ngInject*/
    function LayoutController($stateParams, dataservice){

        setEmbded();

        function setEmbded(){
            if($stateParams.embded){
                dataservice.page.setEmbded($stateParams.embded);
            }
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/layout.controller.js
 ** module id = 220
 ** module chunks = 0
 **/